'use strict';

require('./salary-questionnaire.scss');

module.exports = {
  template: require('./salary-questionnaire.html'),
  controller: require('./salary-questionnaire.controller'),
  controllerAs: 'vm',

  bindings: {
    token: '<',
    step: '<',
    data: '<',
    me: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-questionnaire/index.js
 ** module id = 212
 ** module chunks = 0
 **/